"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Update = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var userInfo_1 = require("../../model/userInfo");
var service_1 = require("../../../library/base/service");
var Update = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Update, _super);
    function Update() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '个人信息修改接口';
        _this.code = '101057';
        _this.desc = '个人信息修改接口';
        _this.requestParams = new userInfo_1.UpdateRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Update;
}(service_1.BaseService));
exports.Update = Update;
//# sourceMappingURL=update.js.map